// 跟进记录render
import React from 'react';
import PropTypes from 'prop-types';
import PhoneInfo from '@/business-components/sale/PhoneInfo';
import CustomerInfo from '@/business-components/sale/CustomerInfo';
import Money from '@/components/Money';
import { Ellipsis } from '@tencent/spaui-business';
import _ from 'lodash';
import LinkButton from '@/components/LinkButton';
import UserInfo from '@/business-components/sale/UserInfo';
import AgencyName from '@/pages/leads/highSeas/AssignToAgency/AgencyName.tsx';
import { REACT_APP_PUBLIC_URL, CLEANING_STATUS, PROGRESS_STATUS } from '@/constants/Constants';
import PotentialReason from '@/business-components/sale/PotentialReasonSelect/PotentialReason';

class ActionRecordDescription extends React.PureComponent {
  static propTypes = {
    lead: PropTypes.object.isRequired,
    potential: PropTypes.object,
    order: PropTypes.object,
    actionRecord: PropTypes.shape({
      actionType: PropTypes.string.isRequired,
      talkDuration: PropTypes.number,
    }).isRequired,
    maxLength: PropTypes.number,
  }

  static defaultProps = {
    maxLength: 15,
  }

  render() {
    const { lead, potential, order, actionRecord, linkToAccountOpening } = this.props;
    switch (actionRecord.actionType) {
      case 'ACTION_TYPE_LEAD_OBTAIN':
        return <span className={'action-record-desc'}>公海申领 {this.renderDescription(actionRecord, '备注：')}</span>;
      case 'ACTION_TYPE_CREATE_LEAD':
        return <span className={'action-record-desc'}>创建线索 {this.renderDescription(actionRecord, '备注：')}</span>;
      case 'ACTION_TYPE_MACHINE_ASSIGN':
        return <span className={'action-record-desc'}>机器分发 {this.renderDescription(actionRecord, '备注：')}</span>;
      case 'ACTION_TYPE_CHANGE_LEAD_LAYER_TYPE':
        return <span className={'action-record-desc'}>修改线索分层 {this.renderDescription(actionRecord, '备注：')}</span>;
      case 'ACTION_TYPE_CREATE_POTENTIAL':
        return <span className={'action-record-desc'}>线索清洗成功-转商机 {this.renderDescription(actionRecord, '备注：')}{this.renderPotentialReason(actionRecord)}</span>;

      case 'ACTION_TYPE_CUST_AUTO_SELF_DISTRIBUTE': // 官网自助线索
        return <span className={'action-record-desc'}>{this.renderDescription(actionRecord)}</span>;

      case 'ACTION_TYPE_CREATE_ORDER':
        return (
          <span className={'action-record-desc'}>
            到款提单
            {this.renderPaymentInfo(lead, potential, order)}
            {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_ASSIGN':
        return <span className={'action-record-desc'}>分配线索 {this.renderDescription(actionRecord, '备注：')}</span>;

      // A special type which does not exist but named for the first ASSIGN record.
      case 'ACTION_TYPE_DISPATCH':
        return <span className={'action-record-desc'}>下发线索 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_OBTAIN':
        return <span className={'action-record-desc'}>公海池商机申领 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_CLEAN':
        return (
          <span className={'action-record-desc'}>
            {this.renderCleanLeadsDes(actionRecord)} {this.renderDescription(actionRecord, '备注：')}{' '}
          </span>
        );

      case 'ACTION_TYPE_DIAL_OUT':
        return (
          <span className={'action-record-desc'}>
            外呼电话 {this.renderDuration(actionRecord.talkDuration)} {this.renderContact(actionRecord, lead)} {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_DIAL_IN':
        return (
          <span className={'action-record-desc'}>
            呼入电话 {this.renderDuration(actionRecord.talkDuration)} {this.renderContact(actionRecord, lead)} {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_MANUAL_RELEASE':
      case 'ACTION_TYPE_LEAD_MANUAL_RELEASE':
        return <span className={'action-record-desc'}>人工释放，进入公海 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_AUTO_RELEASE':
      case 'ACTION_TYPE_LEAD_AUTO_RELEASE':
        return <span className={'action-record-desc'}>自动释放，进入公海 {this.renderDescription(actionRecord, '原因：')}</span>;

      case 'ACTION_TYPE_REVIEW_ORDER_PAYMENT':
        return (
          <span className={'action-record-desc'}>
            到款审核：{this.renderOrderReviewResult(actionRecord)} {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_REVIEW_ORDER_ONLINE':
        return (
          <span className={'action-record-desc'}>
            上线审核：{this.renderOrderReviewResult(actionRecord)} {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_SUBMIT_PAYMENT':
        return <span className={'action-record-desc'}>提交到款审核 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_SUBMIT_ONLINE':
        return <span className={'action-record-desc'}>提交上线审核 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_RESET':
        return <span className={'action-record-desc'}>重置状态 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_SUBMIT_TO_DISTRIBUTE_POOL':
        return <span className={'action-record-desc'}>提交到分发池 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_DISTRIBUTE_POOL_OBTAIN':
        return <span className={'action-record-desc'}>从分发池领回 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_CREATE_REGISTRATION':
        return (
          <span className={'action-record-desc'}>
            申请开户，开户单ID：
            {linkToAccountOpening ? (
              <a href={`${REACT_APP_PUBLIC_URL}/registration/register/detail?leadId=${lead.leadId}&ticketId=${actionRecord.registrationTicketId}`} target="_blank" rel="noopener noreferrer">
                {actionRecord.registrationTicketId}
              </a>
            ) : (
              <span>{actionRecord.registrationTicketId}</span>
            )}
            {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_CLOSE_REGISTRATION':
        return <span className={'action-record-desc'}>中途关闭开户单 {this.renderDescription(actionRecord, '备注：')}</span>;

      case 'ACTION_TYPE_FINISH_REGISTRATION':
        return (
          <span className={'action-record-desc'}>
            开户成功, 账户ID：{actionRecord.customerId ? actionRecord.customerId : actionRecord.weChatAppId}
            {this.renderDescription(actionRecord, '备注：')}
          </span>
        );

      case 'ACTION_TYPE_EXTERNAL_IMPORT':
        return <span className={'action-record-desc'}>{this.renderDescription(actionRecord)}</span>;

      case 'ACTION_TYPE_CREATE_OUTSIDE':
        return <span className={'action-record-desc'}>{this.renderOutsideTicketInfo(actionRecord, '申请外勤')}</span>;

      case 'ACTION_TYPE_CLOSE_OUTSIDE':
        return <span className={'action-record-desc'}>{this.renderOutsideTicketInfo(actionRecord, '中途关闭外勤单')}</span>;

      case 'ACTION_TYPE_FINISH_OUTSIDE':
        return <span className={'action-record-desc'}>{this.renderOutsideTicketInfo(actionRecord, '正常结束外勤单')}</span>;

        // 分发服务商记录
      case 'ACTION_TYPE_DISTRIBUTE_AGENCY_LEAD':
        return <span className={'action-record-desc'}>{this.renderDistributeAgency(actionRecord)}</span>;
      case 'ACTION_TYPE_ACCEPT_AGENCY_LEAD':
        return <span className={'action-record-desc'}>{this.renderAcceptAgency(actionRecord)}</span>;

      // 关联企微记录
      case 'ACTION_TYPE_BIND_ONLINE_SALES_CUSTOMER':
        return <span className={'action-record-desc'}>{this.renderBindWorkWechat(actionRecord)}</span>;
      // 取消关联企微记录
      case 'ACTION_TYPE_UNBIND_ONLINE_SALES_CUSTOMER':
        return <span className={'action-record-desc'}>{this.renderUntieWorkWechat(actionRecord)}</span>;
      // 账户已上线
      case 'ACTION_TYPE_CUST_COST':
        return (
          <span className={'action-record-desc'}>
            {this.renderDescription(actionRecord)}
          </span>
        );
      case 'ACTION_TYPE_CUSTOMIZE':
      default:
        return <span className={'action-record-desc'}>{this.renderDescription(actionRecord)}{this.renderPotentialReason(actionRecord)}</span>;

      case 'ACTION_TYPE_BATCH_TRANSFER_OWNER':
        return <span className={'action-record-desc'}>批量转移 {this.renderBatchTransferOwner(actionRecord)}</span>;
    }
  }

  renderDistributeAgency = (actionRecord) => {
    return <span>
      分发服务商：<AgencyName agencyId={actionRecord.distributeAgencyId} />；线索ID：{actionRecord.leadId}，操作人为<UserInfo userId={actionRecord.actionHandlerId} />
      {this.renderDescription(actionRecord)}
    </span>;
  }

  renderAcceptAgency = (actionRecord) => {
    return <span>
      接收线索，操作人为<UserInfo userId={actionRecord.actionHandlerId} />
      {this.renderDescription(actionRecord)}
    </span>;
  }

  renderUntieWorkWechat = (actionRecord) => {
    return <>
      <p>解绑企微</p>
      <span>联系人-{actionRecord.contactName} 取消关联 企微-{actionRecord.relationCustomerName}</span>
    </>;
  }

  renderBindWorkWechat = (actionRecord) => {
    return <>
    <p>关联企微</p>
    <span>联系人-{actionRecord.contactName} 关联 企微-{actionRecord.relationCustomerName}</span>
  </>;
  }

  renderOutsideTicketInfo(actionRecord, desc) {
    let resultType = '';
    if (actionRecord.outsideResultType) {
      switch (actionRecord.outsideResultType) {
        case 'OUTSIDE_RESULT_TYPE_ORDER_SUBMITTABLE':
          resultType = '[建议提单]';
          break;
        case 'OUTSIDE_RESULT_TYPE_ORDER_UNSUBMITTABLE':
          resultType = '[暂不建议提单]';
          break;
        default:
          break;
      }
    }
    return (
      <span>
        {desc}
        {resultType} 外勤单 ID:
        <LinkButton to={{ pathname: `/outside/detail/${actionRecord.outsideTicketId}` }}>{actionRecord.outsideTicketId}</LinkButton>
        {this.renderDescription(actionRecord, '备注：')}
      </span>
    );
  }

  renderDuration(duration) {
    if (!duration) {
      return null;
    }
    return `${duration}s`;
  }

  renderContact(actionRecord, lead) {
    const { contactName, contactId, contactPhone } = actionRecord;
    const { leadId = '' } = lead || {};
    return (
      <div>
        {contactName} <PhoneInfo
        leadDetail={lead}
        leadId={leadId}
        contactId={contactId}
        number={contactPhone}
        enabled={false}
        reloadPage={this.props.reloadPage}
      />
      </div>
    );
  }

  renderDescription(actionRecord, prefix) {
    if (!actionRecord.description) {
      return null;
    }
    return (
      <span className={'description'}>
        {prefix}
        <Ellipsis maxCount={this.props.maxLength}>{actionRecord.description}</Ellipsis>
      </span>
    );
  }

  // 意向原因展示
  renderPotentialReason = (actionRecord) => {
    if (actionRecord.newPotentialSecondSeasonType && PROGRESS_STATUS.PROGRESS_STATUS_POTENTIAL === actionRecord.oldProgressStatus) {
      return <p>
        意向原因：<PotentialReason potentialStatus={actionRecord.newPotentialSecondSeasonType} />
      </p>;
    }
    return null;
  }

  renderCleanLeadsDes = (record) => {
    let des = '清洗线索';
    if (record.newCleaningStatus) {
      const [status] = CLEANING_STATUS.filter((v) => v.value === record.newCleaningStatus);
      if (status) {
        des += `-${status.label}`;
      }
    }
    if (record.cleaningReason) {
      des += `-${record.cleaningReason}`;
    }
    return des;
  }

  renderOrderReviewResult(actionRecord) {
    switch (actionRecord.newOrderStatus) {
      case 'ORDER_STATUS_PAID':
      case 'ORDER_STATUS_ONLINE':
        return '通过';
      case 'ORDER_STATUS_UNPAID':
      case 'ORDER_STATUS_NOT_ONLINE':
        return '拒绝';
      default:
        return null;
    }
  }

  renderPaymentInfo = (lead, potential, order) => {
    let customerSpan;
    if (lead.customerId || lead.customerMpUserName) {
      customerSpan = _.isEmpty(lead.customerMpUserName) ? (
        <span>
          账户 ID：
          <CustomerInfo customerId={lead.customerId} />，
        </span>
      ) : (
        <span>
          MP 广告帐号：
          <CustomerInfo customerId={lead.customerId} mpUserName={lead.customerMpUserName} />，
        </span>
      );
    } else if (potential && (potential.customerId || potential.customerMpUserName)) {
      customerSpan = _.isEmpty(potential.customerMpUserName) ? (
        <span>
          账户 ID：
          <CustomerInfo customerId={potential.customerId} />，
        </span>
      ) : (
        <span>
          MP 广告帐号：
          <CustomerInfo customerId={potential.customerId} mpUserName={potential.customerMpUserName} />，
        </span>
      );
    }
    if (order) {
      return (
        <span>
          <br />
          {customerSpan}
          首次到款金额：
          <Money value={order.firstPaymentAmount} />， 服务费：
          <Money value={order.serviceFee} />
        </span>
      );
    } if (potential && potential.firstPaymentAmount) {
      return (
        <span>
          <br />
          {customerSpan}
          首次到款金额：
          <Money value={potential.firstPaymentAmount} />， 服务费：
          <Money value={potential.serviceFee} />
        </span>
      );
    }
  }

  renderBatchTransferOwner(actionRecord) {
    return '';
  }
}

export default ActionRecordDescription;
